import { cn } from "@/lib/utils";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "./ui/card";
import { Tilt } from "./ui/tilt";
import { GlowEffect } from "./ui/glow-effect";
import { useState } from "react";
import { motion } from "motion/react";
import { IsOnlineBadge } from "./IsOnlineBage";

export default function ProjectCard({
  href,
  title,
  description,
  logo,
  imageClassName,
}: {
  href: string;
  title: string;
  description: string;
  logo: string | React.ReactNode;
  imageClassName?: string;
}) {
  const [hovered, setHovered] = useState(false);

  return (
    <Tilt
      rotationFactor={5}
      isRevese
      springOptions={{ stiffness: 400, damping: 30 }}
    >
      <motion.a
        layout
        href={href}
        target="_blank"
        className="block h-full flex-1"
      >
        <Card
          className="w-75 h-full justify-between relative"
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
        >
          <IsOnlineBadge
            url={href}
            size="sm"
            className="absolute top-4 right-4"
          />
          <CardHeader className="gap-4">
            <CardTitle className="text-2xl font-bold">{title}</CardTitle>
            <CardDescription className="min-h-[2em]">
              {description}
            </CardDescription>
          </CardHeader>
          <CardContent className="">
            <div className="relative w-fit mx-auto">
              <motion.div
                className="pointer-events-none absolute inset-0"
                animate={{ opacity: hovered ? 1 : 0 }}
                transition={{ duration: 0.3, ease: "easeInOut" }}
              >
                <GlowEffect mode="colorShift" />
              </motion.div>
              {typeof logo === "string" ? (
                <img
                  src={logo}
                  alt={`${title} logo`}
                  className={cn(
                    "w-16 h-16 mx-auto rounded-lg relative",
                    imageClassName,
                  )}
                />
              ) : (
                logo
              )}
            </div>
          </CardContent>
        </Card>
      </motion.a>
    </Tilt>
  );
}
